import { ChangeDetectionStrategy, Component, EnvironmentInjector, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatIcon } from '@angular/material/icon';
import { ChatStore } from '@coin/chat-bot-data-access';
import { AuthService } from '@coin/shared/auth/data-access';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'coin-chat-bot',
  templateUrl: './chat-bot.component.html',
  styleUrl: './chat-bot.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIcon, TranslateModule],
  host: {
    'animate.enter': 'fade-in'
  }
})
export class ChatBotComponent {
  private readonly chatStore = inject(ChatStore);
  private readonly environmentInjector = inject(EnvironmentInjector);
  private readonly authService = inject(AuthService);
  protected readonly isAuthenticated = toSignal(this.authService.isAuthenticated$, { initialValue: false });

  constructor() {
    this.chatStore.setChatDialogLoader(() =>
      import('../chat-dialog/create-chat-dialog-portal').then(({ createChatDialogPortal }) =>
        createChatDialogPortal(this.environmentInjector)
      )
    );
  }

  toggleChat() {
    this.chatStore.toggle();
  }
}
